import { SVGProps } from "react"

const PauseIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.6511 2.5H10.2775C9.98616 2.5 9.75 2.70932 9.75 2.96753V12.3182C9.75 12.5764 9.98616 12.7857 10.2775 12.7857H12.6511C12.9424 12.7857 13.1786 12.5764 13.1786 12.3182V2.96753C13.1786 2.70932 12.9424 2.5 12.6511 2.5Z"
        fill={"currentColor"}
      />
      <path
        d="M5.79172 2.5H3.4181C3.12678 2.5 2.89062 2.70932 2.89062 2.96753V12.3182C2.89062 12.5764 3.12678 12.7857 3.4181 12.7857H5.79172C6.08304 12.7857 6.3192 12.5764 6.3192 12.3182V2.96753C6.3192 2.70932 6.08304 2.5 5.79172 2.5Z"
        fill={"currentColor"}
      />
    </svg>
  )
}
export default PauseIcon
